import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbOutgoingDocReceivers", {params: params});
  },

  findAllHistory(docId){
    let params = {docId: docId};
    return httpService.get("/vbOutgoingDocReceivers/findAllHistory",{params: params})
  }
};



// WEBPACK FOOTER //
// ./src/services/vbOutgoingDocReceiversService.js